import { Component, input } from '@angular/core';

@Component({
  selector: 'rid-labeled-card',
  imports: [],
  templateUrl: './rid-labeled-card.html',
})
export class RidLabeledCard {
  label = input.required<string>();
  mainText = input.required<string>();
  showShadow = input<boolean>(false);
}
